<mat-label class="text-gray"> {{label}}</mat-label><br>
<mat-radio-group [formControl]="formControl" [disabled]="disabled">
    @for (option of options; track option) {
    <mat-radio-button [value]="option.value">{{option.viewValue}}</mat-radio-button>
    }
</mat-radio-group>